import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0" }
const _hoisted_2 = { class: "card-toolbar m-0" }
const _hoisted_3 = {
  class: "nav nav-stretch fs-5 fw-semobold nav-line-tabs nav-line-tabs-2x border-transparent",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger d-flex justify-content-between align-items-center"
}
const _hoisted_8 = {
  key: 1,
  class: "d-flex justify-content-center py-10"
}
const _hoisted_9 = {
  id: "kt_referred_users_tab_content",
  class: "tab-content"
}
const _hoisted_10 = {
  key: 0,
  class: "py-0 tab-pane fade active show",
  role: "tabpanel"
}
const _hoisted_11 = {
  key: 0,
  class: "text-center text-muted py-8"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card pt-2 ${_ctx.cardClasses}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h2", null, "Invoices")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.getDataByYear(0)), ["prevent"])),
              class: _normalizeClass(["nav-link text-active-primary", { active: _ctx.selectedYear === 0 }]),
              "data-bs-toggle": "tab",
              role: "tab"
            }, " All ", 2)
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (item, index) => {
            return _createElementVNode("li", {
              key: index,
              class: "nav-item",
              role: "presentation"
            }, [
              (item === 1)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.getDataByYear(new Date().getFullYear())), ["prevent"])),
                    class: _normalizeClass(["nav-link text-active-primary", { active: _ctx.selectedYear === new Date().getFullYear() }]),
                    "data-bs-toggle": "tab",
                    role: "tab"
                  }, " This Year ", 2))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.getDataByYear(new Date().getFullYear() + 1 - item)), ["prevent"]),
                    class: _normalizeClass(["nav-link text-active-primary", { active: _ctx.selectedYear === new Date().getFullYear() + 1 - item }]),
                    "data-bs-toggle": "tab",
                    role: "tab"
                  }, _toDisplayString(new Date().getFullYear()+1 - item), 11, _hoisted_5))
            ])
          }), 64))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_ctx.loadError), 1),
            _createElementVNode("button", {
              class: "btn btn-sm btn-light-danger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getDataByYear(_ctx.selectedYear)))
            }, "Retry")
          ]))
        : (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("span", { class: "spinner-border spinner-border-sm me-3" }, null, -1),
              _createTextVNode(" Loading invoices... ", -1)
            ]))]))
          : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.isLoading && !_ctx.loadError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_Datatable, {
                "table-header": _ctx.tableHeader,
                "table-data": _ctx.data,
                "rows-per-page": 5,
                "enable-items-per-page-dropdown": false
              }, {
                "cell-IssueDate": _withCtx(({ row: invoice }) => [
                  _createTextVNode(_toDisplayString(_ctx.dateFormat(invoice.IssueDate)), 1)
                ]),
                "cell-DueDate": _withCtx(({ row: invoice }) => [
                  _createTextVNode(_toDisplayString(_ctx.dateFormat(invoice.DueDate)), 1)
                ]),
                "cell-TotalAmount": _withCtx(({ row: invoice }) => [
                  _createTextVNode(_toDisplayString(_ctx.currencyFormat(invoice.TotalAmount, invoice.Currency)), 1)
                ]),
                "cell-Currency": _withCtx(({ row: invoice }) => [
                  _createTextVNode(_toDisplayString(invoice.Currency), 1)
                ]),
                "cell-CurrencyRate": _withCtx(({ row: invoice }) => [
                  _createTextVNode(_toDisplayString(invoice.CurrencyRate), 1)
                ]),
                "cell-Status": _withCtx(({ row: invoice }) => [
                  _createTextVNode(_toDisplayString(invoice.Status), 1)
                ]),
                _: 1
              }, 8, ["table-header", "table-data"]),
              (_ctx.data.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_ctx.selectedYear === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "No invoices were found for this vendor."))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, "No invoices were found for this vendor in " + _toDisplayString(_ctx.selectedYear) + ".", 1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _cache[5] || (_cache[5] = _createElementVNode("div", {
          id: "kt_customer_details_invoices_4",
          class: "py-0 tab-pane fade",
          role: "tabpanel"
        }, null, -1))
      ])
    ])
  ], 2))
}